import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { CommunityService, CommunityStateOrigin } from '../../services/community.service';
import { CookieService } from 'ngx-cookie';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { AuthenticationService } from '@adeo/ngx-kozikaza-api';
import { tap } from 'rxjs/operators';
import { DateService } from '../../services/utilities/date.service';

@Component({
  selector: 'app-i18n-disclaimer',
  templateUrl: './i18n-disclaimer.component.html',
  styleUrls: ['./i18n-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class I18nDisclaimerComponent implements OnInit, OnDestroy {

  public hidden$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  private subscription: Subscription;

  constructor(
    private readonly communityService: CommunityService,
    private readonly cookieService: CookieService,
    private readonly authenticationService: AuthenticationService,
    private readonly dateService: DateService,
  ) {
  }

  ngOnInit(): void {
    this.subscription = combineLatest([ this.communityService.isCommunityChanges, this.authenticationService.authenticatedUser]).pipe(
      tap(([isCommunity, userLogged]) =>
        (!isCommunity.isCommunity && isCommunity.communityStateOrigin !== CommunityStateOrigin.BY_KAZA_COUNTRY && !userLogged) ?
          this.show() : this.hide())
    ).subscribe();

    const alreadyClosed = !!this.cookieService.get('kozikaza_i18n_disclaimer');

    if (alreadyClosed) {
      return;
    }

    this.hide();
  }

  ngOnDestroy(): void {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }

  get hidden(): Observable<boolean> {
    return this.hidden$.asObservable();
  }

  hide() {
    this.hidden$.next(true);

    this.cookieService.put('kozikaza_i18n_disclaimer', 'true', {
      domain: environment.COOKIE_DOMAIN,
      path: '/',
      expires: this.dateService.addYears(1),
    });
  }

  show() {
    this.hidden$.next(false);
  }
}
